import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { EventListenerType } from '@/src/application/hooks/enums/EventListenerEnum';
import { SendActionsPostMessage } from '@/src/compat/sendActionsPostMessage';
import useMessage from '@/src/compat/useMessage';

export const useGetActionRecurringMessage = () => {
  const { campaignId, actionId } = useParams();
  const [showSpinnerByAction, setShowSpinnerByAction] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [infoCampaignV1, setInfoCampaignV1] = useState({
    campaign: { id: 0, name: '' },
    action: { id: 0, name: '' },
  });

  useMessage(EventListenerType.Loaded, (_) => {
    console.log('Loaded');
    showSpinnerByAction && setIsLoading(true);
  });

  useEffect(() => {
    const type = 'manual';
    isLoading &&
      showSpinnerByAction &&
      SendActionsPostMessage('Campaign', 'ViewReportCampaign', { id: actionId, type });
  }, [showSpinnerByAction, isLoading, actionId]);

  useMessage(EventListenerType.LoadedReport, (_, payload) => {
    if (isLoading && showSpinnerByAction) {
      // cspell:disable
      setInfoCampaignV1({
        campaign: {
          id: parseInt(campaignId || '0'),
          name: payload?.campaniaNombre ?? '',
        },
        action: {
          id: parseInt(actionId || '0'),
          name: payload?.nombre ?? '',
        },
      });
      // cspell:enable
      setShowSpinnerByAction(false);
    }
  });

  useEffect(() => {
    SendActionsPostMessage('Campaign', 'VerifyLoaded');
  }, []);

  return {
    actionId,
    actionName: infoCampaignV1.action.name,
    actionIsLoading: showSpinnerByAction,
  };
};
